import { Injectable, effect, signal } from '@angular/core';
import { Layout, LayoutBaseFontSize, LayoutMenuTheme } from '../enums/layout.enum';


@Injectable({ providedIn: 'root' })
export class LayoutService {
  private _defaultLayout = Layout.Horizontal;

  layout = signal(this._defaultLayout);
  darkTheme = signal(localStorage.getItem('dark-theme') === 'true');
  layoutMenuTheme = signal(LayoutMenuTheme.Surface);
  layoutBaseFontSize = signal(LayoutBaseFontSize.Small);
  isOverlaySidebarVisible = signal(true);

  revertLayoutToDefault() {
    this.layout.set(this._defaultLayout);
    this.isOverlaySidebarVisible.set(false);
  }

  constructor() {
    effect(() => localStorage.setItem('dark-theme', `${this.darkTheme()}`));
  }
}
